import { useMemo } from 'react';
import {
	filterKeys,
	nullSafeGetOrElse,
	parseFilterValueToAdvancedFilters,
} from '../../utils/DataAccessUtils';
import { SORTING_PROPS } from '../../utils/DataConstants';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { getWorkOrderArchivalKey } from '../../utils/WorkOrderUtils';

function WorkOrderFiltersWrapper({ children, currentUser, location, defaultView }) {
	const defaultFilters = useMemo(() => {
		if (location && !Boolean(location.search)) {
			const defaultFilterView = nullSafeGetOrElse('filterValue', defaultView, {});
			return filterKeys(
				parseFilterValueToAdvancedFilters(defaultFilterView),
				[...SORTING_PROPS, getWorkOrderArchivalKey(currentUser)],
				false
			);
		}
	}, [defaultView, location]);

	return children(defaultFilters); // Pass filters to child as render prop
}

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
	defaultView: state.session.defaultView,
});

const mapDispatchToProps = (dispatch, ownProps) => ({});
const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(WorkOrderFiltersWrapper)
);
export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(Form.create()(ComponentWithoutUserType));
